import type {Router, RouteRecordRaw} from 'vue-router';
import {createRouter, createWebHistory} from 'vue-router';

import type {ESettingsFrontType} from '@/config/enums';
import settings from '@/config/settings';

import {ERoleSystem} from '@/api/enums/role';

import {userState} from '@/services/state/user';

import {EAdminRoutesNames} from '@/app/admin/router/enums';
import {ECRoutesNames} from '@/app/client/router/enums';

import {adminRoutes} from '@/app/admin/router';
import {clientRoutes} from '@/app/client/router';

const {hasAccessByRole} = userState;
const {hasAccessByMode} = settings.SERVICES.FRONT;

const {isClient} = userState;
const {IS_ADMIN, IS_CLIENT} = settings.SERVICES.FRONT;

const routes: Array<RouteRecordRaw> = [];

routes.push(...clientRoutes);
if (IS_ADMIN) routes.push(...adminRoutes);

export let router: Router | undefined = undefined;

export const getRouter = () => router as Router;
export const initRouter = () => {
  router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
  });

  router.beforeEach(async (to, from, next) => {
    const accessRoles: ERoleSystem[] =
      (to.meta?.access_roles as ERoleSystem[]) ?? [];
    const accessMode: ESettingsFrontType[] =
      (to.meta?.access_mode as ESettingsFrontType[]) ?? [];

    if (to.path !== from.path) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    if (IS_CLIENT) {
      if (!hasAccessByMode(accessMode))
        next({name: ECRoutesNames.CNotFoundPage});
      else if (!hasAccessByRole(accessRoles))
        next({name: ECRoutesNames.CForbiddenPage});
      else next();
      return;
    }

    if (IS_ADMIN) {
      if (isClient.value) await userState.signOut();

      if (!hasAccessByMode(accessMode))
        next({name: EAdminRoutesNames.AdminNotFoundPage});
      else if (!hasAccessByRole(accessRoles))
        next({name: EAdminRoutesNames.AdminForbiddenPage});
      else next();
      return;
    }

    next();
  });

  return router;
};
